import axios from "axios";
import { getNodeUrl, hasCustomNode } from "./getNodeUrl";

const testnetNodes = ["https://nodes-testnet.wavesnodes.com"];

const mainnetNodes = [
  "https://nodes.wx.network",
  "https://nodes-puzzle.wavesnodes.com",
  "https://nodes.wavesnodes.com",
  "https://nodes.swop.fi",
  "https://wavesducks.wavesnodes.com"
];

interface IParams {
  chainId?: "T" | "W";
  postData?: any;
}

const makeNodeRequest = async (
  request: string,
  params?: IParams
): Promise<any> => {
  const defaultNodes =
    params?.chainId == null || params.chainId === "W"
      ? mainnetNodes
      : testnetNodes;
  
  const nodes = hasCustomNode() 
    ? [getNodeUrl(), ...defaultNodes]
    : defaultNodes;
  
  if (hasCustomNode()) {
    console.log('[makeNodeRequest] Using custom node:', getNodeUrl());
  }
  
  return new Promise(async (resolve, reject) => {
    let nodeIndex = 0;
    let success = false;
    while (!success) {
      const url = nodes[nodeIndex] + request;
      console.log('[makeNodeRequest] Trying:', url);
      try {
        const response = await (params?.postData == null
          ? axios.get(url)
          : axios.post(url, params.postData));
        success = true;
        resolve(response);
      } catch (reason) {
        if (nodeIndex === nodes.length - 1) {
          success = true;
          reject(reason);
        } else {
          nodeIndex = nodeIndex + 1;
        }
      }
    }
  });
};

export default makeNodeRequest;
